import { render, staticRenderFns } from "./ListaOcorrencias.vue?vue&type=template&id=009f27c6&"
import script from "./ListaOcorrencias.vue?vue&type=script&lang=js&"
export * from "./ListaOcorrencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports